import { query } from '@/services/graphql';
import * as operations from './operations';

export default {
  checkMatch(variables = {}) {
    return query(operations.CHECK_MATCH, variables, false);
  },
  matchInfo(variables = {}) {
    return query(operations.MATCH_INFO, variables, false);
  },
};
